import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative flex flex-col w-full bg-white rounded-lg p-6 border border-gray-300 shadow min-h-[140px] items-stretch my-4" }
const _hoisted_2 = { class: "flex flex-row gap-6 w-full items-start" }
const _hoisted_3 = { class: "flex flex-col items-center w-24 h-24 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0 -ml-6 -mt-6" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex flex-col flex-1 min-w-0 justify-center pl-2" }
const _hoisted_6 = { class: "flex flex-row items-start justify-between w-full" }
const _hoisted_7 = { class: "flex flex-col min-w-0" }
const _hoisted_8 = { class: "font-semibold text-xl text-gray-900 leading-7 mb-1" }
const _hoisted_9 = { class: "text-base text-gray-600 leading-6 mb-2" }
const _hoisted_10 = { class: "flex flex-row items-center gap-2" }
const _hoisted_11 = { class: "flex flex-col gap-2 mt-6" }
const _hoisted_12 = { class: "text-sm text-gray-700 whitespace-pre-line leading-6" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.previewImg,
          alt: "Landing Page Preview",
          class: "object-cover w-full h-full rounded-lg"
        }, null, 8, _hoisted_4),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-xs text-gray-500 mt-1 text-center font-medium" }, "Landing Page", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.title), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.subtitle), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "flex items-center gap-2 bg-gray-100 text-primary-purple px-4 py-2 rounded-md text-sm font-semibold hover:bg-primary-purple hover:text-white transition",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPreviewPage && _ctx.openPreviewPage(...args)))
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("span", null, "Edit page", -1)
            ])),
            _createElementVNode("button", {
              class: "flex items-center gap-2 bg-gray-100 text-primary-purple px-4 py-2 rounded-md text-sm font-semibold hover:bg-primary-purple hover:text-white transition",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPreviewPage && _ctx.openPreviewPage(...args)))
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("span", null, "Preview Page", -1)
            ]))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-semibold text-base mb-1 text-gray-900" }, "About the Program", -1)),
      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.about), 1),
      _createElementVNode("button", {
        class: "flex items-center gap-2 w-fit mt-2 bg-gray-100 text-primary-purple px-3 py-1.5 rounded text-sm font-medium hover:bg-primary-purple hover:text-white transition",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args)))
      }, [
        _createElementVNode("span", {
          innerHTML: _ctx.NOTE_ICON,
          class: "w-5 h-5 self-center relative top-[1px]"
        }, null, 8, _hoisted_13),
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.isCopied ? "Copied!" : "Copy"), 1)
      ])
    ])
  ]))
}